import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS } from "@/lib/data";
import { scrollToSection } from "@/lib/scroll";

const Footer = () => {
  return (
    <footer className="relative bg-[#0F1E3D] text-[#FAFAF8] pt-20 lg:pt-28 pb-10 overflow-hidden" data-testid="footer">
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <img src={BRAND.logoLight} alt="JM Investment Advisory" className="h-11 w-auto object-contain" />
              <span className="font-trajan text-sm sm:text-base font-medium uppercase tracking-[0.18em]">JM Investment Advisory</span>
            </div>
            <p className="font-serif-display text-3xl lg:text-5xl tracking-tight leading-[1.05] max-w-xl">
              Your hard-earned money, working for your family.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-[#C89933] mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => {
                const key = l.route || l.target;
                const testid = `footer-nav-${(l.route || l.target).replace(/[/]/g, "")}`;
                const cls = "text-[#FAFAF8]/70 hover:text-[#C89933] transition-colors duration-300";
                return (
                  <li key={key}>
                    {l.route ? (
                      <Link to={l.route} className={cls} data-testid={testid}>{l.label}</Link>
                    ) : (
                      <button onClick={() => scrollToSection(l.target)} className={cls} data-testid={testid}>{l.label}</button>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-[#C89933] mb-6">Reach Us</p>
            <ul className="space-y-3 text-[#FAFAF8]/70 text-sm font-light">
              <li className="text-[#FAFAF8]">{BRAND.contactPerson}</li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#C89933] transition-colors duration-300">{BRAND.email}</a>
              </li>
              <li>
                <a href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#25D366] transition-colors duration-300">
                  WhatsApp · {BRAND.whatsappDisplay}
                </a>
              </li>
              <li>{BRAND.location}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[#FAFAF8]/50 text-xs font-light">
            © {new Date().getFullYear()} JM Investment Advisory. All rights reserved.
          </p>
          <p className="overline text-[0.6rem] text-[#7F8D76]">{BRAND.sebi} · Fee-Only Fiduciary</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
